import i18n from "config/i18next";

i18n.addResources("es", "polygonGeneral", {
  schedule: "Horarios",
  distances: "Distancias",
  transactions: "Transacciones",
  restriction: "Restricción",
  rainBonus: "Bonus por lluvia",
  startOfOperationTime: "Comienzo de la operación*",
  endOfOperationTime: "Fin de la operación*",
  maxForBoundary: "Distancia máx. al punto de colecta*",
  maxBetweenPoints: "Distancia máx. entre punto de colecta y de entrega*",
  trip: "Viajes",
  kilometers: "(Kilómetros)",
  enterTime: "Ingresá la hora",
  enterDistance: "Ingresá la distancia",
  enterCapacity: "Ingresá la capacidad",
  initialGreaterThanEnd: "Ingresar un horario posterior a la hora de comienzo",
  minimumOneHour: "La diferencia con el comienzo debe ser de al menos una hora",
  changeQuantity: "Modificar cantidad",
  inProgress: "En curso : ",
  next: "Próximo programado :",
  detail: "Detalle",
  colect: "Colecta",
  pickUpMaxCapacity: "Capacidad máx. de paquetes en simultáneo*",
  tripMaxDistance: "Distancia máx. entre entregas*",
  pickUpMaxCapacityAmountError: "No debe superar los 30 paquetes.",
});

i18n.addResources("es_MX", "polygonGeneral", {
  maxBetweenPoints: "Dist. máx. entre punto de colecta y de última entrega*",
});
